<app-header class="alternate-theme" />
<main>
  <router-outlet></router-outlet>
</main>

<app-cookie-overlay />

<app-footer class="alternate-theme" />

<app-chat />

<app-google-tag-manager-wrapper />
<app-google-recaptcha-wrapper />
